// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"63":"b9076968","360":"d101367e","526":"17e2dda0","535":"01dc434e","572":"e403ffbb","750":"2d2b2b1f","801":"ca296909"}[chunkId] + ".css";
};